<template>
  <div>
    <b-img thumbnail width="120" :src="imageUrl" fluid alt="-" v-if="imageUrl"></b-img>

    <b-form-file class="text-nowrap text-truncate"
        accept="image/*"
        v-model="image"
        placeholder="Upload hình ảnh..."
    ></b-form-file>
    <!-- <div class="mt-3">Selected file: {{ image ? image.name : '' }}</div> -->

    <b-button v-if="!isLoading" variant="success" class="my-3" @click="uploadImage()">
        Upload
    </b-button>

    <b-button v-if="!isLoading" variant="danger" class="my-3" @click="removeImage()">
        Xoá
    </b-button>

    <b-spinner v-if="isLoading"></b-spinner>

<!-- 
    <b-button v-if="!isNewRecord" variant="success" class="my-3" @click="toggleSelectImages()">
        {{isSelectingImages ? "Bỏ Chọn hình" : "Chọn hình"}}
    </b-button>

    <b-button v-if="isSelectingImages" @click="deleteSelectedImages()" variant="danger" class="my-3 ml-2">
        Xóa hình đang chọn
    </b-button>

    <div v-bind:class="{ 'selecting': isSelectingImages }">
        <div v-for="(date_images,i) in input.value" v-bind:key="date_images.date + i" class="mr-2">
            <div class="my-3"><em>{{date_images.date}}</em></div>
            <div>
                <div v-for="(image,i) in date_images.images" v-bind:key="image.url + i" class="image thumbnail" v-bind:class="{ 'active': image.selected }">
                    <img :src="image.url" @click="toggleImage(image)">
                </div>
            </div>
        </div>
    </div> -->
  </div>
</template>

<script>

import Firebase from "../../services/firebase.js"

export default {
  name: 'ImageFormField',
  data () {
    return {
      image: null,
      imageUrl: '',
      isLoading: false
    }
  },
  watch: {
    image_url: function (newVal, oldVal) {
      if(newVal) {
          this.imageUrl = newVal;
      }
    }
  },
  methods: {
    async uploadImage() {
        if(!this.image)
            return;

        this.isLoading = true;

        var storage = Firebase.getStorage().ref().child('images');
        var filenamePart = this.image.name.split('.');

        const fileName = filenamePart[0] + '-' + Date.now() + '.' + filenamePart[1];

        try {
            var snapshot = await storage.child(fileName).put(this.image);
            this.imageUrl = await snapshot.ref.getDownloadURL();
            this.$emit('image_changed', this.imageUrl);

            // console.log('imageurl: ', this.imageUrl);
        } catch (err) {
            console.log('error while uploading images', err);
        }

        this.isLoading = false;
    },

    removeImage() {
        this.imageUrl = '';
        this.$emit('image_changed', '');
    }
  },
  props: ['image_url'],
  mounted () {
      this.imageUrl = this.image_url;
  }
}
</script>

<style scoped>

</style>
